import {parseResponse, PortfolioHandlerResource} from "../../../utils/api";
import React, {useState} from "react";
import _ from "lodash";
import {useTabsSharedDataContext} from "../components_v2/TabsSharedData/TabsSharedData";
import {generateQueryParamsHash} from "../utils";
import {isCancel, useCancelableRequest} from "../../../hooks/useCancelableRequest";

const SHARED_DATA_KEY = 'performance-forecast-data';

export function usePerformanceForecastData(customerId, portfolios, dataProvider=PortfolioHandlerResource, assets, investmentStrategyId) {
  const [data, setData] = useState({
    data: null,
    errors: null,
    loading: false,
    updatedAt: +new Date()
  });

  const getCancelToken = useCancelableRequest();
  const sharedData = useTabsSharedDataContext();

  React.useEffect(() => {
    if (!!customerId && !_.isEmpty(portfolios)) {
      const sharedPortfolioData = !!sharedData
        ? sharedData.getDataValue(SHARED_DATA_KEY, generateQueryParamsHash(customerId, portfolios))
        : undefined;

      // fetch data if there is no shared data or shared data was loaded with error
      if (!!sharedPortfolioData && !sharedPortfolioData.errors) {
        // sync internal hook data with shared data.
        setData(sharedPortfolioData);
      } else {
        fetch()
      }
    }
  }, [customerId, JSON.stringify(portfolios)]);

  async function fetch() {
    const cancelToken = getCancelToken();

    const _setState = (state, onlyCache=false) => {
      // It is not possible to sync data with shared data in
      // hook because hook is not executed if component destroyed
      if(!onlyCache) setData(state);
      sharedData.setDataValue(SHARED_DATA_KEY, hashKey, state);
    };

    const hashKey = generateQueryParamsHash(customerId, portfolios);

    _setState({
      data: null,
      errors: null,
      loading: true,
      updatedAt: +new Date()
    });

    try {

      const portfoliosIds = portfolios.filter(portfolio => !!portfolio.depotNumber).map(portfolio => portfolio.depotNumber);

      const response = await dataProvider.getPortfolioForecast(
        customerId, portfoliosIds, assets, investmentStrategyId, cancelToken
      );
      /** Parse extended_asset_data data */
      parseResponse(response, 'performance_forecast', (data) => {
        _setState({
          data: data,
          errors: null,
          loading: false,
          updatedAt: +new Date()
        });
      }, (errors) => {
        _setState({
          data: null,
          errors: errors,
          loading: false,
          updatedAt: +new Date()
        });
      });

    } catch (errors){
      _setState({
        data: null,
        errors: errors,
        loading: false,
        updatedAt: +new Date()
      }, isCancel(errors));
    }
  }

  return data;
}